module.exports = __webpack_public_path__ + "static/media/md.824e3e16.svg";